export default __webpack_public_path__ + "static/media/lttape3.90ec5a95.webp";